/* ACTION TYPES */

export const SET_LOGIN_FORM_FIELD = 'event-guestside-site/registrantLogin/SET_LOGIN_FORM_FIELD';

export const RESEND_CONFIRMATION_PENDING = 'event-guestside-site/registrantLogin/RESEND_CONFIRMATION_PENDING';
export const RESEND_CONFIRMATION_SUCCESS = 'event-guestside-site/registrantLogin/RESEND_CONFIRMATION_SUCCESS';

export const LOG_IN_REGISTRANT_SUCCESS = 'event-guestside-site/registrantLogin/LOG_IN_REGISTRANT_SUCCESS';
export const LOG_IN_REGISTRANT_FAILURE = 'event-guestside-site/registrantLogin/LOG_IN_REGISTRANT_FAILURE';

export const LOG_OUT_REGISTRANT_PENDING = 'event-guestside-site/registrantLogin/LOG_OUT_REGISTRANT_PENDING';
export const LOG_OUT_REGISTRANT_SUCCESS = 'event-guestside-site/registrantLogin/LOG_OUT_REGISTRANT_SUCCESS';
export const LOG_OUT_REGISTRANT_FAILURE = 'event-guestside-site/registrantLogin/LOG_OUT_REGISTRANT_FAILURE';

export const RESET_STATUS = 'event-guestside-site/registrantLogin/RESET_STATUS';

export const UPDATE_USER_SESSION = 'event-guestside-site/registrantLogin/UPDATE_USER_SESSION';
export const UPDATE_CURRENT_REGISTRANT_LOGIN = 'event-guestside-site/registrantLogin/UPDATE_CURRENT_REGISTRANT_LOGIN';
